export default __webpack_public_path__ + "static/media/logo3.d5d073d5.png";